// Text tools - transforms, counts, encoders, and hashes.
import { el, btn, ta, wrap, copy, announce } from "./ui.js";

const titleCase = (s) => s.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
const sentenceCase = (s) => s.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => c.toUpperCase());
const lines = (s) => s.split(/\r?\n/);

async function sha(algo, s) {
	const buf = await crypto.subtle.digest(algo, new TextEncoder().encode(s));
	return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function text(root) {
	const s = wrap(root); s.classList.add("rv-text");
	const inp = ta({ placeholder: "Type or paste text…" }); inp.classList.add("rv-text-in");
	inp.setAttribute("aria-label", "Text");
	const outp = ta({ readOnly: true }); outp.classList.add("rv-text-out");
	outp.id = "rv-text-out";
	const stats = el("div", "rv-text-stats");

	function setOut(v) { outp.value = v == null ? "" : v; announce(outp.value ? "Result ready" : "No result"); }
	function count() {
		const v = inp.value;
		const words = (v.trim().match(/\S+/g) || []).length;
		stats.textContent = v.length + " chars · " + words + " words · " + lines(v).length + " lines";
	}
	inp.addEventListener("input", count);

	const ops = [
		["UPPER", (v) => v.toUpperCase()],
		["lower", (v) => v.toLowerCase()],
		["Title", titleCase],
		["Sentence", sentenceCase],
		["Reverse", (v) => v.split("").reverse().join("")],
		["Sort lines", (v) => lines(v).sort((a, b) => a.localeCompare(b)).join("\n")],
		["Dedupe", (v) => [...new Set(lines(v))].join("\n")],
		["Trim", (v) => lines(v).map((l) => l.trim()).filter(Boolean).join("\n")],
		["Base64 →", (v) => { try { return btoa(unescape(encodeURIComponent(v))); } catch (e) { return "Error"; } }],
		["→ Base64", (v) => { try { return decodeURIComponent(escape(atob(v.trim()))); } catch (e) { return "Error"; } }],
		["URL →", (v) => encodeURIComponent(v)],
		["→ URL", (v) => { try { return decodeURIComponent(v); } catch (e) { return "Error"; } }],
		["JSON format", (v) => { try { return JSON.stringify(JSON.parse(v), null, 2); } catch (e) { return "Invalid JSON"; } }],
		["JSON minify", (v) => { try { return JSON.stringify(JSON.parse(v)); } catch (e) { return "Invalid JSON"; } }],
	];
	const grid = el("div", "rv-text-ops");
	ops.forEach(([label, fn]) => grid.appendChild(btn(label, () => setOut(fn(inp.value)), "rv-tbtn")));
	["SHA-256", "SHA-1"].forEach((algo) => grid.appendChild(btn(algo, async () => setOut(await sha(algo, inp.value)), "rv-tbtn")));

	const outRow = el("div", "rv-trow");
	outRow.append(btn("Copy result", () => copy(outp.value), "rv-tbtn"), btn("Use as input", () => { inp.value = outp.value; count(); }, "rv-tbtn"));

	const resHead = el("h2", "rv-tool-sub", "Result"); resHead.id = "rv-text-res";
	outp.setAttribute("aria-labelledby", resHead.id);
	s.append(inp, stats, grid, resHead, outp, outRow);
	count();
}
